import { render } from "./AgencyNoteAndRates.vue?vue&type=template&id=5a2c63d1"
import script from "./AgencyNoteAndRates.vue?vue&type=script&lang=js"
export * from "./AgencyNoteAndRates.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__